import { defineMessages } from 'react-intl';

const messages = defineMessages({
  orderDiscountLabel: {
    defaultMessage: 'Discount Total',
    description: 'Label for order discount field in order summary',
    id: 'pC4beL',
  },
  orderDiscountDetails: {
    defaultMessage: 'Details',
    description: 'Label for order discount details button in order summary',
    id: 'PuCCwH',
  },
  discountModalHeader: {
    defaultMessage: 'Order Discount',
    description: 'Header for the order discount modal',
    id: '5zozPQ',
  },
  discountTableDescription: {
    defaultMessage: 'Description',
    description: 'Table header for the order discount table',
    id: '/UwGGZ',
  },
  discountTableDiscountAmount: {
    defaultMessage: 'Discount Amount',
    description: 'Table header for the order discount table',
    id: '6RYBYk',
  },
});

export default messages;
